module.exports = {"pathContext":{"slug":"/en/assessment/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-assessment.json
// module id = 1534
// module chunks = 133845105845689